import type { Resource } from "i18next";

export const mapBundleToResource = (bundle: { [key: string]: string }, language: string): Resource => {
  return {
    [language]: {
      translation: bundle,
    },
  };
}
